import { BucketInfo, SeriesVector, SmoothingDataInput } from './types';

export function createChartDataToSmoothingDataAdapter(
  data: SeriesVector[],
  bucketsByX: Map<number, BucketInfo>[],
): SmoothingDataInput {
  const dataLength = data.length;
  const seriesCount = (data[0]?.length ?? 1) - 1;

  return {
    dataLength,
    seriesCount,
    getXValue,
    getBucket,
  };

  function getXValue(pointIndex: number) {
    return data[pointIndex][0];
  }

  // Series index is 0-based (i.e. it counts only series, without offset for X-axis).
  function getBucket(seriesIndex: number, pointIndex: number): BucketInfo | null {
    const x = data[pointIndex][0];

    const value = data[pointIndex][seriesIndex + 1];
    const yValue = Array.isArray(value) ? value[1] : value;

    if (yValue == null) {
      return null;
    }

    const bucket = bucketsByX[seriesIndex]?.get(x);

    if (!Number.isFinite(yValue) && bucket?.count !== 0) {
      return { sum: yValue, count: 1 };
    }

    return bucket ?? { sum: yValue, count: 1 };
  }
}
